module.exports = __webpack_public_path__ + "img/2500-2_YR_2022_FlashDriveAttacks.d80d58fb.png";